var DealContentLoader, ERR_ABORTED, ERR_CORRUPTED_DATA, ERR_GLIVE_DEAL, ERR_INTERNAL_SERVER_ERROR, ERR_NETWORK_ERROR, ERR_NON_JSON_RESPONSE, ERR_NOT_FOUND, ERR_NOT_LOCAL_DEAL, ERR_NO_MESSAGE, ERR_OTHER_HTTP_CODE, ERR_REQUEST_TIMEOUT, ERR_XHR_UNHANDLED_ERROR, FALLBACK_QUERY_STRING, LOAD_CONTENT_QUERY_STRING, createQueryAndHashURL, fallback, handlers, hector_config, loadContent, onWindowLoad, populateData, request, runHandlers;

handlers = hector_config = request = void 0;

FALLBACK_QUERY_STRING = 'eagerLoad';

LOAD_CONTENT_QUERY_STRING = 'loadContent';

ERR_XHR_UNHANDLED_ERROR = 'XHR throws an unhandled error';

ERR_REQUEST_TIMEOUT = 'Request timeout';

ERR_ABORTED = 'Request aborted';

ERR_NOT_FOUND = 'Not found';

ERR_INTERNAL_SERVER_ERROR = 'Internal server error';

ERR_NETWORK_ERROR = 'Network error';

ERR_OTHER_HTTP_CODE = 'Other http code';

ERR_NON_JSON_RESPONSE = 'Not a json response';

ERR_NO_MESSAGE = 'No message provided';

ERR_CORRUPTED_DATA = 'Response data is corrupted';

ERR_NOT_LOCAL_DEAL = 'Not a local deal';

ERR_GLIVE_DEAL = 'It is a Glive deal';

createQueryAndHashURL = function(paramAndValue, isFallback) {
  var queryAndHash;
  queryAndHash = paramAndValue;
  if (isFallback) {
    queryAndHash += window.location.hash;
  }
  if (window.location.search) {
    return window.location.search + "&" + queryAndHash;
  } else {
    return "?" + queryAndHash;
  }
};

fallback = function(errMsg) {
  var raw, redirect;
  redirect = function() {
    return window.DealContentLoader._redirectTo(createQueryAndHashURL(FALLBACK_QUERY_STRING, true));
  };
  if (errMsg == null) {
    errMsg = ERR_NO_MESSAGE;
  }
  raw = {
    _csrf: $("meta[name='csrf-token']").attr('content'),
    errMsg: errMsg,
    xhr_status: request != null ? request.status : void 0,
    xhr_readyState: request != null ? request.readyState : void 0
  };
  try {
    return $.ajax({
      data: raw,
      complete: redirect,
      method: 'POST',
      timeout: (hector_config != null ? hector_config.reporterTimeout : void 0) || 1000
    });
  } catch (error) {
    return redirect();
  }
};

runHandlers = function() {
  if (handlers != null) {
    return handlers.forEach(function(handler) {
      return handler();
    });
  }
};

populateData = function(data) {
  if (!data || typeof data !== 'object' || !data.content_html) {
    return fallback(ERR_CORRUPTED_DATA);
  }
  document.title = data.deal_title;
  $('section.main.deal-content-placeholder').replaceWith(data.content_html);
  DealTrackContentLoaded(BOOMR.track_deal_loadtime);
  GIG.Tooltip.reloadBindings();
  GIG.Modal.reloadBindings();
  $('body').addClass('qa-content-loaded');
  return runHandlers();
};

loadContent = function() {
  return request = $.ajax({
    url: createQueryAndHashURL(LOAD_CONTENT_QUERY_STRING, false),
    dataType: 'json',
    timeout: (hector_config != null ? hector_config.loadContentTimeout : void 0) || 5000,
    error: function(jqXHR, textStatus) {
      switch (textStatus) {
        case 'timeout':
          return fallback(ERR_REQUEST_TIMEOUT);
        case 'abort':
          return fallback(ERR_ABORTED);
        case 'parsererror':
          return fallback(ERR_NON_JSON_RESPONSE);
        case 'error':
          switch (jqXHR.status) {
            case 0:
              return fallback(ERR_NETWORK_ERROR);
            case 404:
              return fallback(ERR_NOT_FOUND);
            case 500:
              return fallback(ERR_INTERNAL_SERVER_ERROR);
            default:
              return fallback(ERR_OTHER_HTTP_CODE);
          }
      }
    },
    success: populateData
  });
};

onWindowLoad = function() {
  var ref;
  BOOMR.track_deal_loadtime = +new Date();
  if (DealContentLoader.loadEnabled) {
    hector_config = typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Utils) != null ? typeof ref.getConfigFromDom === "function" ? ref.getConfigFromDom() : void 0 : void 0 : void 0;
    if (!(hector_config != null ? hector_config.shouldLazyLoadDeal : void 0)) {
      return runHandlers();
    } else {
      try {
        return loadContent();
      } catch (error) {
        return fallback(ERR_XHR_UNHANDLED_ERROR);
      }
    }
  } else {
    return runHandlers();
  }
};

DealContentLoader = window.DealContentLoader = {
  addOnLoadHandler: function(handler) {
    if (typeof handler === "function") {
      return handlers.push(handler);
    }
  },
  init: function(loadEnabled) {
    this.loadEnabled = loadEnabled;
    handlers = [];
    return $(window).load(onWindowLoad);
  },
  _redirectTo: function(url) {
    return window.location.replace(url);
  }
};

module.exports = DealContentLoader;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2RlYWxfY29udGVudF9sb2FkZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9kZWFsL2Zyb250ZW5kL2RlYWxfY29udGVudF9sb2FkZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsUUFBQSxHQUFXLGFBQUEsR0FBZ0IsT0FBQSxHQUFVOztBQUNyQyxxQkFBQSxHQUF3Qjs7QUFDeEIseUJBQUEsR0FBNEI7O0FBRzVCLHVCQUFBLEdBQTBCOztBQUMxQixtQkFBQSxHQUFzQjs7QUFDdEIsV0FBQSxHQUFjOztBQUNkLGFBQUEsR0FBZ0I7O0FBQ2hCLHlCQUFBLEdBQTRCOztBQUM1QixpQkFBQSxHQUFvQjs7QUFDcEIsbUJBQUEsR0FBc0I7O0FBQ3RCLHFCQUFBLEdBQXdCOztBQUN4QixjQUFBLEdBQWlCOztBQUNqQixrQkFBQSxHQUFxQjs7QUFDckIsa0JBQUEsR0FBcUI7O0FBQ3JCLGNBQUEsR0FBaUI7O0FBRWpCLHFCQUFBLEdBQXdCLFNBQUMsYUFBRCxFQUFnQixVQUFoQjtBQUN0QixNQUFBO0VBQUEsWUFBQSxHQUFlO0VBQ2YsSUFBRyxVQUFIO0lBQ0UsWUFBQSxJQUFnQixNQUFNLENBQUMsUUFBUSxDQUFDLEtBRGxDOztFQUdBLElBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFuQjtBQUNFLFdBQVUsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFqQixHQUF3QixHQUF4QixHQUEyQixhQUR0QztHQUFBLE1BQUE7QUFHRSxXQUFPLEdBQUEsR0FBSSxhQUhiOztBQUxzQjs7QUFVeEIsUUFBQSxHQUFXLFNBQUMsTUFBRDtBQUNULE1BQUE7RUFBQSxRQUFBLEdBQVcsU0FBQTtXQUNULE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxXQUF6QixDQUFxQyxxQkFBQSxDQUFzQixxQkFBdEIsRUFBNkMsSUFBN0MsQ0FBckM7RUFEUztFQUdYLElBQUksY0FBSjtJQUNFLE1BQUEsR0FBUyxlQURYOztFQUdBLEdBQUEsR0FDRTtJQUFBLEtBQUEsRUFBTyxDQUFBLENBQUUseUJBQUYsQ0FBNEIsQ0FBQyxJQUE3QixDQUFrQyxTQUFsQyxDQUFQO0lBQ0EsTUFBQSxFQUFRLE1BRFI7SUFFQSxVQUFBLG9CQUFZLE9BQU8sQ0FBRSxlQUZyQjtJQUdBLGNBQUEsb0JBQWdCLE9BQU8sQ0FBRSxtQkFIekI7O0FBS0Y7V0FDRSxDQUFDLENBQUMsSUFBRixDQUNFO01BQUEsSUFBQSxFQUFNLEdBQU47TUFDQSxRQUFBLEVBQVUsUUFEVjtNQUVBLE1BQUEsRUFBUSxNQUZSO01BR0EsT0FBQSwyQkFBUyxhQUFhLENBQUUseUJBQWYsSUFBa0MsSUFIM0M7S0FERixFQURGO0dBQUEsYUFBQTtXQU9FLFFBQUEsQ0FBQSxFQVBGOztBQWJTOztBQXNCWCxXQUFBLEdBQWMsU0FBQTtFQUNaLElBQUcsZ0JBQUg7V0FDRSxRQUFRLENBQUMsT0FBVCxDQUFpQixTQUFDLE9BQUQ7YUFDZixPQUFBLENBQUE7SUFEZSxDQUFqQixFQURGOztBQURZOztBQUtkLFlBQUEsR0FBZSxTQUFDLElBQUQ7RUFDYixJQUFHLENBQUMsSUFBRCxJQUFTLE9BQU8sSUFBUCxLQUFpQixRQUExQixJQUFzQyxDQUFDLElBQUksQ0FBQyxZQUEvQztBQUNFLFdBQU8sUUFBQSxDQUFTLGtCQUFULEVBRFQ7O0VBR0EsUUFBUSxDQUFDLEtBQVQsR0FBaUIsSUFBSSxDQUFDO0VBQ3RCLENBQUEsQ0FBRSx1Q0FBRixDQUEwQyxDQUFDLFdBQTNDLENBQXVELElBQUksQ0FBQyxZQUE1RDtFQUNBLHNCQUFBLENBQXVCLEtBQUssQ0FBQyxtQkFBN0I7RUFDQSxHQUFHLENBQUMsT0FBTyxDQUFDLGNBQVosQ0FBQTtFQUNBLEdBQUcsQ0FBQyxLQUFLLENBQUMsY0FBVixDQUFBO0VBQ0EsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLFFBQVYsQ0FBbUIsbUJBQW5CO0FBR0EsU0FBTyxXQUFBLENBQUE7QUFaTTs7QUFjZixXQUFBLEdBQWMsU0FBQTtTQUNaLE9BQUEsR0FBVSxDQUFDLENBQUMsSUFBRixDQUNSO0lBQUEsR0FBQSxFQUFLLHFCQUFBLENBQXNCLHlCQUF0QixFQUFpRCxLQUFqRCxDQUFMO0lBQ0EsUUFBQSxFQUFVLE1BRFY7SUFFQSxPQUFBLDJCQUFTLGFBQWEsQ0FBRSw0QkFBZixJQUFxQyxJQUY5QztJQUdBLEtBQUEsRUFBTyxTQUFDLEtBQUQsRUFBUSxVQUFSO0FBQ0wsY0FBUSxVQUFSO0FBQUEsYUFDTyxTQURQO0FBRUksaUJBQU8sUUFBQSxDQUFTLG1CQUFUO0FBRlgsYUFHTyxPQUhQO0FBSUksaUJBQU8sUUFBQSxDQUFTLFdBQVQ7QUFKWCxhQUtPLGFBTFA7QUFNSSxpQkFBTyxRQUFBLENBQVMscUJBQVQ7QUFOWCxhQU9PLE9BUFA7QUFRSSxrQkFBTyxLQUFLLENBQUMsTUFBYjtBQUFBLGlCQUNPLENBRFA7QUFFSSxxQkFBTyxRQUFBLENBQVMsaUJBQVQ7QUFGWCxpQkFHTyxHQUhQO0FBSUkscUJBQU8sUUFBQSxDQUFTLGFBQVQ7QUFKWCxpQkFLTyxHQUxQO0FBTUkscUJBQU8sUUFBQSxDQUFTLHlCQUFUO0FBTlg7QUFRSSxxQkFBTyxRQUFBLENBQVMsbUJBQVQ7QUFSWDtBQVJKO0lBREssQ0FIUDtJQXFCQSxPQUFBLEVBQVMsWUFyQlQ7R0FEUTtBQURFOztBQXlCZCxZQUFBLEdBQWUsU0FBQTtBQUNiLE1BQUE7RUFBQSxLQUFLLENBQUMsbUJBQU4sR0FBNEIsQ0FBQyxJQUFJLElBQUosQ0FBQTtFQUM3QixJQUFHLGlCQUFpQixDQUFDLFdBQXJCO0lBQ0UsYUFBQSx3SUFBOEIsQ0FBRTtJQUNoQyxJQUFBLDBCQUFPLGFBQWEsQ0FBRSw0QkFBdEI7YUFDRSxXQUFBLENBQUEsRUFERjtLQUFBLE1BQUE7QUFHRTtlQUNFLFdBQUEsQ0FBQSxFQURGO09BQUEsYUFBQTtlQUdFLFFBQUEsQ0FBUyx1QkFBVCxFQUhGO09BSEY7S0FGRjtHQUFBLE1BQUE7V0FVRSxXQUFBLENBQUEsRUFWRjs7QUFGYTs7QUFjZixpQkFBQSxHQUFvQixNQUFNLENBQUMsaUJBQVAsR0FDbEI7RUFBQSxnQkFBQSxFQUFrQixTQUFDLE9BQUQ7SUFDaEIsSUFBRyxPQUFPLE9BQVAsS0FBa0IsVUFBckI7YUFDRSxRQUFRLENBQUMsSUFBVCxDQUFjLE9BQWQsRUFERjs7RUFEZ0IsQ0FBbEI7RUFJQSxJQUFBLEVBQU0sU0FBQyxXQUFEO0lBQUMsSUFBQyxDQUFBLGNBQUQ7SUFDTCxRQUFBLEdBQVc7V0FDWCxDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsSUFBVixDQUFlLFlBQWY7RUFGSSxDQUpOO0VBUUEsV0FBQSxFQUFhLFNBQUMsR0FBRDtXQUNYLE1BQU0sQ0FBQyxRQUFRLENBQUMsT0FBaEIsQ0FBd0IsR0FBeEI7RUFEVyxDQVJiOzs7QUFXRixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
